let offers;
let selectedVariant;
let product;
let selectedWarranty;
let warrantyReady;
let warrantyRequestId = 0;

function getSelectedWarrantyVariantId() {
    // The current product form owns the selection; the legacy global can be stale.
    const field = document.querySelector('#product-variant-id') || document.querySelector('.form-id');
    return field?.value || window.selectedVariantId || product?.variants[0]?.id;
}

function updateWarrantySelection() {
    const toggle = document.querySelector('.mulberry_widget .product-addons__toggle');
    selectedWarranty = toggle?.checked && offers?.[1] ? { offer: offers[1] } : null;
}

async function mulberryInit() {
    const rsp = await mulberryShop.getProductData(mulberryShop.getProductUrl());
    product = rsp.product;
    await checkVariant(getSelectedWarrantyVariantId());
}

document.addEventListener('mulberry-shopify:loaded', function () {
    setupXHRListeners();
    setupFetchListeners();

    const toggle = document.querySelector(".mulberry_widget .product-addons__toggle");
    if (toggle) {
        toggle.addEventListener('change', updateWarrantySelection);
    }

    const allowedPaths = new Set([
      '/collections/frontpage/products/ezlift-bed-hi-lo',
      '/products/ez-lift-sleep-to-stand-bed',
      '/products/ezlift-sleep-to-stand-bed-cvrwstst',
      '/products/ezlift-bed-hi-lo',
      '/products/elevra-deluxe-rotating-hi-lo-lift-bed',
      '/products/elevra-deluxe-rotating-lift-bed',
      '/products/ezlift-deluxe-sleep-to-stand-bed',
      '/products/ezlift-bed%E2%84%A2-deluxe-sleep-to-stand-bed',
      '/products/the-ezlift-deluxe-refurbished'
    ]);

    if (allowedPaths.has(window.location.pathname)) {
        warrantyReady = mulberryInit();
        warrantyReady.catch(err => console.error('Mulberry initialization failed:', err));

        const formIdField = document.querySelector('#product-variant-id') || document.querySelector('.form-id');
        if (formIdField) {
          const refreshVariant = () => {
            warrantyReady = warrantyReady.catch(() => {}).then(() => checkVariant(formIdField.value));
            warrantyReady.catch(err => console.error('Mulberry variant update failed:', err));
          };
          // product.js writes .value and dispatches a non-bubbling change event.
          formIdField.addEventListener('change', refreshVariant);
          const observer = new MutationObserver(mutations => {
            for (let mutation of mutations) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                refreshVariant();
              }
            }
          });
        
          // Observe changes to the 'value' attribute
          observer.observe(formIdField, {
            attributes: true,
            attributeFilter: ['value']
          });
        }

        // EzLift: the bed (+ add-ons) is added first by product.js; it then awaits window.ezliftAfterBedAdded
        // (bounded) BEFORE it refreshes/opens the cart drawer, so the plan is added strictly after the bed and the
        // drawer shows bed + add-ons + plan in one refresh. Previously the plan was added on click, racing the bed's
        // /cart/add.js; the slower bed+protector request could overwrite (or be overwritten by) the plan add, and a
        // plan landing after the drawer refresh never appeared there. Falls back to the click if product.js isn't handling the form.
        let pendingWarranty = null;
        const currentWarrantyChoice = () => ({ variantId: getSelectedWarrantyVariantId(), paidRequested: Boolean(toggle?.checked) });
        document.querySelector(".submit_add_cart")?.addEventListener('click', function () {
            const choice = currentWarrantyChoice();
            if (window.ezliftAtcEvents) { pendingWarranty = choice; return; }
            addWarrantyForBed(choice.variantId, choice.paidRequested, false);
        });
        window.ezliftAfterBedAdded = function (bedVariantId) {
            const choice = pendingWarranty || currentWarrantyChoice();
            pendingWarranty = null;
            return addWarrantyForBed(bedVariantId || choice.variantId, choice.paidRequested, true);
        };
        document.addEventListener('ezlift:atc-failed', function () { pendingWarranty = null; });

        async function addWarrantyForBed(variantId, paidRequested, callerRefreshesCart) {
            try {
                await warrantyReady;
                const cartVariant = product?.variants.find(i => i.id == variantId);
                if (!cartVariant) { console.info('[ezlift] Mulberry plan skipped: bed variant not found', variantId); return; }
                const cartOffers = String(selectedVariant?.id) === String(variantId) ? offers : await mulberry.core.getWarrantyOffer({
                    id: cartVariant.id,
                    title: product.title,
                    price: cartVariant.price,
                    detail: product
                });
                const paidOffer = paidRequested ? cartOffers?.[1] : null;
                const offer = paidOffer || cartOffers?.[0];
                if (!offer) { console.info('[ezlift] Mulberry plan skipped: no offer for', variantId); return; }
                // Included coverage must never silently become a paid add-on.
                if (!paidOffer && Number(offer.cost) !== 0) { console.info('[ezlift] Mulberry plan skipped: included offer is not $0', offer.cost); return; }
                const owner = { title: product.title, variantId: cartVariant.id };
                const result = await mulberryShop.getWarrantyVariant(offer);
                const planInCart = async () => {
                    const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
                    return cart.items.some(i => String(i.properties?._variantId) === String(cartVariant.id));
                };
                await mulberryShop.addWarrantyToCart(result.shopify_variant_id, owner, offer);
                // addWarrantyToCart ignores the response; confirm the plan landed and retry once if not.
                if (!(await planInCart())) {
                    await mulberryShop.addWarrantyToCart(result.shopify_variant_id, owner, offer);
                }
                console.info('[ezlift] Mulberry plan added for bed', cartVariant.id);
                if (!callerRefreshesCart) document.querySelector('cart-slide')?.refreshCart();
            } catch (err) {
                console.log('mulberry error: ', err);
            }
        }
    } else if(window.location.href.indexOf("/cart")){
      removeAndSyncWarranties();
    }
});

async function removeAndSyncWarranties(reload = true) {
    const response = await fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    });

    const firstCart = await response.json();
    const newCart = await mulberryShop.removeDetachedWarranty(firstCart);
    const content = await mulberryShop.cart.syncQuantities(newCart);

    // if(!reload){
    //   document.dispatchEvent(new Event('updateCart'));
    // }else{
    //   if(firstCart.original_total_price !== content.original_total_price || firstCart.item_count !== content.item_count){
    //     window.location.reload();
    //   }
    // }
}

const throttle = (func, limit) => {
    let inThrottle;
    return function () {
        const args = arguments;
        const context = this;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(() => inThrottle = false, limit);
        }
    };
};

let bool = true;

// document.addEventListener('mulberry-shopify:warranty-added', throttle(function () {
//     setTimeout(() => {
//         removeAndSyncWarranties();
//     }, 800);
// }, 2000));

document.addEventListener('mulberry-trigger-remove-and-sync', () => {
    removeAndSyncWarranties();
});

function dispatchUrlChange() {
    const event = new Event('urlchange');
    window.dispatchEvent(event);
}

(function (history) {
    const pushState = history.pushState;
    const replaceState = history.replaceState;

    history.pushState = function (state) {
        pushState.apply(history, arguments);
        dispatchUrlChange();
    };

    history.replaceState = function (state) {
        replaceState.apply(history, arguments);
        dispatchUrlChange();
    };
})(window.history);


async function checkVariant(variant) {
    const nextVariant = product?.variants.find(i => i.id == variant);
    if (nextVariant) {
        const requestId = ++warrantyRequestId;
        const nextOffers = await mulberry.core.getWarrantyOffer({
            id: nextVariant.id,
            title: product.title,
            price: nextVariant.price,
            detail: product
        });
        if (requestId !== warrantyRequestId) return;
        mulberryShop.selectedVariantId = nextVariant.id;
        selectedVariant = nextVariant;
        offers = nextOffers || [];
        updateWarrantySelection();

        const widget = document.querySelector('.mulberry_widget');
        if (!widget) return;
        if (offers.length > 1) {
            document.querySelector('.mulberry_widget .product-addons__info strong').textContent = `Additional 5 year Warranty +$${offers[1].cost}`;
            widget.style.cssText = 'display: flex';
        } else {
            widget.style.cssText = 'display: none !important';
        }

        // mulberry.inline.updateOffer(offers);
    }
}

window.addEventListener("load", (event) => {
  setTimeout(() => {
    document.dispatchEvent(new Event('asyncLazyLoad'));    
  }, 500);
});

function setupXHRListeners() {
  const origOpen = XMLHttpRequest.prototype.open;

  XMLHttpRequest.prototype.open = function(method, url, ...rest) {
    this._requestUrl = url;

    this.addEventListener('load', async function() {
      const urlString = this._requestUrl ? this._requestUrl.toString() : '';

      if (urlString.includes("cart/change")) {
        try {
          const body = JSON.parse(this.responseText);
          await removeAndSyncWarranties();
          
          const cartSlide = document.querySelector('cart-slide');
          if (cartSlide) {
            cartSlide.refreshCart();
          }
        } catch (err) {
          console.error('Error processing XHR response:', err);
        }
      }
    });

    return origOpen.apply(this, [method, url, ...rest]);
  };
}

function setupFetchListeners() {
  const { fetch: origFetch } = window;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    let requestUrl = args[0];
    if (typeof requestUrl === 'string') {
      requestUrl = requestUrl.toString();
      if (requestUrl.includes("cart/change")) {
        response
          .clone()
          .json()
          .then(async (body) => {
            await removeAndSyncWarranties();
            window.location.reload();
          })
          .catch((err) => console.error(err));
      }
    }
    return response;
  };
}
